import * as React from "react";
import { connect } from "react-redux";

import { RootState } from "../../state";
import { featuredProjectsSelector, companySelector } from "../selectors";
import ProjectsSection from "./ProjectsSection";

interface OwnProps {
  editable?: boolean;
  locale: string;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const ProjectsSectionContainer: React.SFC<Props> = props => {
  const { projects, company, editable, locale } = props;
  return <ProjectsSection projects={projects} company={company} editable={editable} locale={locale} />;
};

function mapStateToProps(state: RootState) {
  const projects = featuredProjectsSelector(state);
  const company = companySelector(state)!;
  return { projects, company };
}

export default connect(mapStateToProps)(ProjectsSectionContainer);



// WEBPACK FOOTER //
// ./frontend/src/companies/components/ProjectsSectionContainer.tsx